import { useQuery } from "@tanstack/react-query";

import { quoteRequestLineCustomInputsQuery } from "#modules/quoteRequestLines/infra/quoteRequestLineCustomInputs.query";

export const useQuoteRequestLineCustomInputs = (
  id: string | undefined,
  options?: { enabled?: boolean },
) => {
  const { data, ...rest } = useQuery({
    ...quoteRequestLineCustomInputsQuery(id),
    ...options,
  });

  return { customInputs: data ?? [], ...rest };
};
